/**
 * @description 页面逻辑基类
 * @author zhijie.huang
 * @date 2018/9/11
 */
import Logic from './logic'
import Auth from './authorize'
import Debug from './api-test'

class LogicBase {
  constructor () {
    return new Logic({Auth, Debug})
  }
}

export default LogicBase
